<template>
  <div>
    <h4 class="title is-5 s-b-margin">{{ formatUnitName(notification.unit) }} ({{ notification.lastReading }}/{{
      notification.notificationTrigger }} km)</h4>

    <div class="tags no-b-margin">
      <span class="tag" v-for="(email, index) in this.notification.emails" :key="index">
        {{ email }}
      </span>
    </div>

    <p class="m-b-margin">
      {{ $t("notifications.lastExecutionDate", { notificationDate: notificationDate.toLowerCase() }) }}
    </p>

    <div class="field" v-if="editMode">
      <label class="label">{{ $t("misc.triggerInKm") }}</label>
      <div class="control">
        <input class="input" v-model="editedTrigger" type="number" min="1" :placeholder="$t('misc.triggerInKm')">
      </div>
    </div>

    <div class="buttons">
      <button v-if="!editMode" @click="this.editNotification" class="button">{{ $t("misc.edit") }}</button>
      <button v-if="editMode" @click="this.saveEdit" class="button is-primary">{{ $t("misc.save") }}</button>
      <button @click="$emit('delete-notification', notification)" class="button is-danger">{{ $t("misc.delete")
        }}</button>
      <button v-if="editMode" @click="this.cancelEdit" class="button">{{ $t("misc.cancel") }}</button>

      <button v-if="notification.status == 'disabled' && !editMode" @click="$emit('enable-notification', notification)"
        class="button is-success">{{ $t("misc.enable") }}</button>
      <button v-if="notification.status == 'active' && !editMode" @click="$emit('disable-notification', notification)"
        class="button is-danger">{{ $t("misc.disable") }}</button>

      <button @click="$emit('refresh-notification', notification)" class="button is-primary">{{ $t("misc.refresh")
        }}</button>
    </div>

    <hr />
  </div>
</template>

<script>

const moment = require('moment');

import { formatUnitName } from "@/utils/format";

export default {
  name: "NotificationRow",
  props: {
    notification: Object
  },
  data: function () {
    return {
      editMode: false,
      editedTrigger: ""
    }
  },
  computed: {
    notificationDate: function () {
      if (this.notification.lastReadingTime == null) return this.$t("misc.never");
      return moment.unix(this.notification.lastReadingTime).format("DD/MM/YYYY HH:mm:ss")
    }
  },
  methods: {
    formatUnitName: formatUnitName,
    editNotification: function () {
      this.editMode = true;
    },
    cancelEdit: function () {
      this.editMode = false;
    },
    saveEdit: function () {
      this.editMode = false;

      this.notification.notificationTrigger = parseInt(this.editedTrigger);
      this.$emit('update-notification', this.notification);
    }
  },
  mounted: function () {
    this.editedTrigger = this.notification.notificationTrigger;
  }
};

</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .button {
    width: 100%;
    margin-right: 0px !important;
  }
}
</style>